import { render, staticRenderFns } from "./PromotionImportLogModal.vue?vue&type=template&id=1c255d68&scoped=true"
import script from "./PromotionImportLogModal.vue?vue&type=script&lang=js"
export * from "./PromotionImportLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c255d68",
  null
  
)

export default component.exports